import { useTranslation } from '@modernloop/i18n';
import { Stack, Typography } from '@mui/material';
import type { FC } from 'react';

type Props = {
  /** Vertical space the fallback occupies so surrounding layout does not collapse. */
  minHeight?: number | string;
};

/**
 * Compact fallback for section-scoped `ErrorBoundary` wrappers. Unlike the
 * default full-page fallback, this keeps the surrounding page (navigation,
 * sibling sections) intact and only replaces the crashed section, so one broken
 * widget cannot take down a whole view.
 */
export const SectionErrorFallback: FC<Props> = ({ minHeight = 120 }) => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ minHeight, p: 2 }}>
      <Typography align="center" color="text.secondary" variant="body2">
        <span aria-label="sad" role="img">
          😢
        </span>{' '}
        {t('common:shared.error.genericRetry')}
      </Typography>
    </Stack>
  );
};
